import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ViewContainerRef,
  inject,
} from '@angular/core';

import { CarouselModule } from 'primeng/carousel';

import { InternalChartComponent } from '@cxc/ui-kit/chart.js/components/internal-chart';

import { ConcentrationGeneralOverviewComponent } from '@pages/dashboard/portfolio/general-overview/components/general-overview-graphs/concentration-general-overview/concentration-general-overview.component';

import { API } from '@models/API';

import { mockedChartsData } from '@pages/dashboard/portfolio/general-overview/portfolio-details/mocked-charts-data';

@Component({
  selector: 'app-general-overview-portfolio-details',
  standalone: true,
  imports: [
    CarouselModule,
    ConcentrationGeneralOverviewComponent,
    InternalChartComponent,
  ],
  templateUrl: './portfolio-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortfolioDetailsPage {
  destroyRef = inject(DestroyRef);
  viewContainerRef = inject(ViewContainerRef);

  ChartEnum = API.Trusts.ChartName;

  charts: API.Chart[] | any[] = mockedChartsData;
  // In the future use this
  // decodedCharts = this.charts.map(chart =>
  //   decodeChart(chart, this.destroyRef, this.viewContainerRef)
  // );
}
